if( document.querySelector('.js-cs') ) {

    const cursorContainer = document.querySelector(".js-cs");

    //Lets get all the elements that are animated.
    const animatedElements = document.querySelectorAll('.js-animate');

    // Create the observer like the examples above
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let animationType = entry.target.dataset.animation;
            if (entry.isIntersecting) {
                entry.target.classList.add('animate__'+animationType);
                return;
            }

            // entry.target.classList.remove('animate__'+animationType);
        });
    });

    // Loop over the elements and add each one to the observer
    animatedElements.forEach((element) => observer.observe(element));

}

if (document.querySelector('.js-schedule-open-day')) {
    //Process opening the accordian on Mobile
    const buttons = document.querySelectorAll('.js-schedule-open-day');
    buttons.forEach(button => {
        button.addEventListener('click', (event) => {
            const target = event.currentTarget;
            const day = target.dataset.target;
            const dayDetails = document.querySelectorAll(`[data-mobile-details="${day}"]`);

            if (dayDetails.length > 0) {
                dayDetails.forEach(el => {
                    el.classList.toggle('open');
                });
            }
        });
    });

    //Process opening the modal
    const openModalButtons = document.querySelectorAll('.js-modal-open');
    openModalButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            const target = event.currentTarget;
            const day = target.dataset.modalopen;
            const dayDetails = document.querySelectorAll(`[data-modaltarget="${day}"]`);

            if (dayDetails.length > 0) {
                dayDetails.forEach(el => {
                    el.classList.toggle('hide');
                });
            }
        });
    });

    //Process closing the modal
    const closeModalButtons = document.querySelectorAll('.js-modal-close');
    closeModalButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            const target = event.currentTarget;
            const day = target.dataset.modalclose;
            const dayDetails = document.querySelectorAll(`[data-modaltarget="${day}"]`);

            if (dayDetails.length > 0) {
                dayDetails.forEach(el => {
                    el.classList.toggle('hide');
                });
            }
        });
    });
}


if(document.querySelector('.js-tournament-schedule-btn')) {
    const btns = document.querySelectorAll('.js-tournament-schedule-btn');
    const structures = document.querySelectorAll('.js-tournament-schedule-content');
    const overlay = document.querySelector('.js-overlay')
    const closeBtns = document.querySelectorAll('.js-tournament-schedule-close');

    const structuresTable = document.querySelectorAll('.js-tournament-schedule-content table');
    structuresTable.forEach(e => e.style.width = '100%')
    btns.forEach(e => {
        e.addEventListener('click', (e) => {
            const id = e.target.dataset.id;
            overlay.classList.remove('hide');
            structures.forEach(st => {
                if (st.dataset.id === id) {
                    st.classList.remove('hide');
                }
            })
        })
    })
    overlay.addEventListener('click', () => {
        structures.forEach(e => e.classList.add('hide'))
        overlay.classList.add('hide');
    })
    closeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            structures.forEach(e => e.classList.add('hide'))
            overlay.classList.add('hide');
        })
    });
}

if(document.querySelector('.js-faq')) {
    const faqs = document.querySelectorAll('.js-faq');

    faqs.forEach((faq) => {
        faq.addEventListener('click', () => {
            faq.querySelector('.js-faq-a').classList.toggle('open');
            faq.querySelector('.js-faq-q').classList.toggle('open');
            faq.querySelector('.js-faq-icon').classList.toggle('open');
        })
    })
}

if(document.querySelector('.js-mobile-tournament')) {
    const tournaments = document.querySelectorAll('.js-mobile-tournament');

    tournaments.forEach((t) => {
        const title = t.querySelector('.js-mobile-tournament-open');
        title.addEventListener('click', () => {
            t.querySelector('.js-mobile-tournament-content').classList.toggle('open');
            title.querySelector('span').classList.toggle('open');
        })
    })
}


//Animate burger menu 

if( document.querySelector('.js-menu-burger') ) {
    const burgerTrigger = document.querySelector('.js-menu-burger');
    const mobileMenu = document.querySelector('.js-mobile-menu');

    burgerTrigger.addEventListener('click', function() {
        this.classList.toggle('header__menu__mobile__burger--open');
        mobileMenu.classList.toggle('hide');

        setTimeout(function() {
            mobileMenu.classList.toggle('header__menu__mobile--hidden');
        }, 100);
    });
}

//Scrolling Desktop Nav
if( document.querySelector('.js-header') ) {
    const header = document.querySelector('.js-header');

    //Nav transition for landing page
    if(document.querySelector('body')) {
        document.addEventListener('scroll', function(e) {
          landingNavTransitions(window.scrollY);
        });
        document.addEventListener('DOMContentLoaded',function(){
            landingNavTransitions(window.scrollY);
        });
        window.addEventListener('resize', function() {
            landingNavTransitions(window.scrollY);
        });
    }
    function landingNavTransitions(scrollPos) {
        if( document.querySelector('html').classList.contains('zf-has-scroll') ) return;
        if(scrollPos < 100) {
            header.classList.remove('header--scrolled');
        } else {
            header.classList.add('header--scrolled');
        }
    }
}

//Gallery
if(document.querySelector('.js-gallery') ) {
    jQuery(document).ready(function ($) {

        $(document).on('open.zf.reveal', '[data-reveal]', function () {
            var modal = $(this);
            //remove the class here
            $('.js-scroll-alt').removeClass('smooth-scroll');
        });

        $(document).on('closed.zf.reveal', '[data-reveal]', function () {
            var modal = $(this);
            //add the class here
            $('.js-scroll-alt').addClass('smooth-scroll');
        });

    });
}

//Slideshow Animation
if(document.querySelector('.js-slide-show') ) {

    let slideShows = document.querySelectorAll('.js-slide-show');
    slideShows.forEach(function(e) {
        let count = Number(e.dataset.count); //This gets the slide count
        let currentCount = 1;

        timeout();

        function timeout() {
            setTimeout(() => {
                e.querySelector('[data-slide="'+currentCount+'"]').classList.remove('slideimg__shown');

                if(currentCount === count) {
                    currentCount = 1;
                } else {
                    currentCount++;
                }

                e.querySelector('[data-slide="'+currentCount+'"]').classList.add('slideimg__shown');

                timeout();

            }, "5000");
        }
    });
}